<template>
  <button 
    :class="['btn', variantClass]"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'success', 
    }
  },
  computed: {
    variantClass() {
      return `btn-${this.variant}`;
    }
  }
};
</script>

<style>
.btn {
  display: flex;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  justify-content: center;
  border-radius: 0.5rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-success {
  background-color: var(--green);
  color: #fff;
}

.btn-shortwidth {
  background-color: var(--green);
  color: #fff;
  width: 9rem;
}

.btn-shortwidth-disabled {
  background-color: var(--gray);
  color: #fff;
  width: 9rem;
  cursor: auto!important;
}

.btn-shortwidth:hover {
  background-color: var(--green_hover);
  color: #fff;
}

.btn-shortwidth:focus {
  background-color: var(--green_focus);
  color: #fff;
}

.btn-border {
  border: 1px solid var(--green);
  color: var(--green);
  width: 9rem;
}

.btn-border:hover {
  background-color: var(--background_button_hover);
}

.btn-border:focus {
  background-color: var(--background_button_focus);
}

.btn-light {
  background-color: #f8f9fa;
  color: #000;
  border: 1px solid #ccc;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
}

.btn-primary {
  background-color: #007bff;
  color: #fff;
}
</style>